import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/services/compliance/page.tsx");
